class GroupTagFilterEntity {}

export default GroupTagFilterEntity
